import computeClassName from '../../../../../utils/computeClassName';

export default function IconHeartSolid({className}) {
  const computedClassName = computeClassName(className,'');
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <path d="M7.23674 4.08331C6.27243 4.08331 5.30684 4.45422 4.58383 5.19454C3.13778 6.67515 3.13967 9.02826 4.58383 10.5098L10.0911 16.1645C10.1428 16.2177 10.2055 16.2602 10.2754 16.2893C10.3452 16.3183 10.4206 16.3333 10.4968 16.3333C10.573 16.3333 10.6484 16.3183 10.7182 16.2893C10.788 16.2602 10.8507 16.2177 10.9025 16.1645C12.7408 14.2822 14.5771 12.3977 16.4155 10.5153C17.8615 9.03471 17.8615 6.68068 16.4155 5.20002C14.9695 3.71935 12.5614 3.71932 11.1154 5.20002L10.4997 5.82406L9.8839 5.19454C9.16087 4.45422 8.20105 4.08331 7.23674 4.08331Z" fill="currentColor"/>
    </svg>
  );
}
